export const navbar = {
  NavBar: {
    backgroundColor: "#D6001C",
  },
  item: {
    color: "white!important",
  },
};
